import { render, staticRenderFns } from "./LoanSVG.vue?vue&type=template&id=338e564e"
import script from "./LoanSVG.vue?vue&type=script&lang=js"
export * from "./LoanSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports